<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="dashboard"
    ></vuse-section-definition>
    <v-container fluid class="fill-height">
      <v-row justify="center" align="center">
<!--        <iframe src="http://localhost:3000/d/3hh6uzM4k/new-dashboard?orgId=1&viewPanel=2"-->
<!--                frameborder="0" width="100%" height="1000" vspace="0" allowtransparency="true">-->
<!--        </iframe>-->
      <div class="contenedor-responsivo">
        <iframe class="iframe-responsivo" 
          src="https://toladata.io/dashboards/public/b30c3fa6-32a9-4d5e-841d-8cf85d906897/15v6-057ba175c7601f60bfbb" 
          title="dashboard"
        >
        </iframe>
      </div>  

      </v-row>
    </v-container>
    <confirm-dialog ref="confirmDialog" title="Acción" message="Esta seguro de realizar esta acción ?" />
  </div>
</template>
<script>
import {exampleService} from "@/infrastructure/Factory";
import {mapActions} from "vuex";
import ConfirmDialog from "@/components/UI/Dialogs/ConfirmDialog";

export default {
  name: 'Home',
  components:{ConfirmDialog},
  data() {
    return {
      page: "Main",
      breadcrumbs: [
        {
          text: "Home",
          disabled: true,
        },
      ],
    };
  },
  methods: {
    ...mapActions(["setShowNotification", "setNotification"]),
    getExampleApi() {
      exampleService.getExampleList()
          .then((r) => console.log('result: getExampleList', r))
          .catch((e) => console.log('error: getExampleList', e))
          .finally(() => console.log('Finally: getExampleList'))
    },
    generateNotificationData(){
      const data = {
        title: 'titulo default',
        text: 'Lorem ipsum dolor sit amet, consecrate adipiscing elit. Fusce in lacinia eros, non malesuada arcu.',
        maxWidth: '500'
      }
      this.setNotification(data)
      this.setShowNotification(true);
    },
    confirmDialogOpen(){
      this.$refs.confirmDialog.open().then((r)=> {
        r ? console.log('Realiza la acción', r) : console.log('Acción cancelada', r)
      })
    }
  },
};
</script>
<style>
  .contenedor-responsivo {
    overflow: hidden;
    /* padding-top: 56.25%; */
  }
  .iframe-responsivo {
    position: absolute;
    top: 100px;
    left: 25px;
    width: 97%;
    height: 100%;
    border: 0;
    overflow-x:hidden;
    overflow-y:hidden;
  }
</style>
